

export default [
    {
        path: "template",
        name: "templist",
        component: () => import(/* webpackChunkName: "virtualstore" */ "@/views/boss/allot/template/index"),
    },
    {
        path: "template/detail/:type",
        name: "tempDetail",
        component: () => import(/* webpackChunkName: "virtualstore" */ "@/views/boss/allot/template/update"),
        meta: {
            bread: false,
        }
    },
    {
        path: "virtualstore/stock",
        name: "vsStock",
        component: () => import(/* webpackChunkName: "virtualstore" */ "@/views/boss/allot/virtualstore/stock/index1"),
        // meta: {
        //     bread: false,
        // }
    },
    {
        path: "virtualstore/stockallocate",
        name: "vsAllot",
        component: () => import(/* webpackChunkName: "virtualstore" */ "@/views/boss/allot/virtualstore/allot/index1"),
        // meta: {
        //     bread: false,
        // }
    },
    {
        path: "virtualstore/stockallocate/detail/:type",
        name: "vsAllotDetail",
        component: () => import(/* webpackChunkName: "virtualstore" */ "@/views/boss/allot/virtualstore/allot/update"),
        meta: {
            bread: false,
        }
    },
    {
        path: "virtualstore/list",
        name: "vstorelist",
        component: () => import(/* webpackChunkName: "virtualstore" */ "@/views/boss/allot/virtualstore/list/index1"),
        // meta: {
        //     bread: false,
        // }
    },
    // 增加仓库
    {
        path: "virtualstore/list/detail/:type",
        name: "vstoreDetail",
        component: () => import(/* webpackChunkName: "virtualstore" */ "@/views/boss/allot/virtualstore/list/update"),
        meta: {
            bread: false,
        }
    },
    {
        path: "virtualstore/list/channel/:type",
        name: "vstoreChannel",
        component: () => import(/* webpackChunkName: "virtualstore" */ "@/views/boss/allot/virtualstore/list/channel"),
        meta: {
            bread: false,
        }
    },
    // 编辑渠道
    {
        path: "virtualstore/list/editorchannel/:id",
        name: "vstoreEditorChannel",
        component: () => import(/* webpackChunkName: "virtualstore" */ "@/views/boss/allot/virtualstore/list/editorchannel"),
        meta: {
            bread: false,
        }
    },
    // 编辑仓库
    {
        path: "virtualstore/list/editorwahouse/:id",
        name: "vstoreEditorWahouse",
        component: () => import(/* webpackChunkName: "virtualstore" */ "@/views/boss/allot/virtualstore/list/editorwarehouse"),
        meta: {
            bread: false,
        }
    },
    // 编辑比例
    {
        path: "virtualstore/list/editorallot/:id",
        name: "vstoreEditorAllot",
        component: () => import(/* webpackChunkName: "virtualstore" */ "@/views/boss/allot/virtualstore/list/editorallot"),
        meta: {
            bread: false,
        }
    },
    // 编辑阶梯
    {
        path: "virtualstore/list/editorladder/:id",
        name: "vstoreEditorLadder",
        component: () => import(/* webpackChunkName: "virtualstore" */ "@/views/boss/allot/virtualstore/list/editorladder"),
        meta: {
            bread: false,
        }
    },
    {
        path: "virtualstore/sku",
        name: "vstoreSku",
        component: () => import(/* webpackChunkName: "virtualstore" */ "@/views/boss/allot/virtualstore/sku/index1"),
        // meta: {
        //     bread: false,
        // }
    },
    {
        path: "virtualstore/waresku",
        name: "vstoreWaresku",
        component: () => import(/* webpackChunkName: "virtualstore" */ "@/views/boss/allot/virtualstore/waresku/index1"),
        // meta: {
        //     bread: false,
        // }
    },

    {
        path: "stockallot/template",
        name: "saTemplate",
        component: () => import(/* webpackChunkName: "stockallot" */ "@/views/boss/allot/stockallot/template/index1"),
        // meta: {
        //     bread: false,
        // }
    },
    {
        path: "stockallot/template/detail/:type",
        name: "saTemplateDetail",
        component: () => import(/* webpackChunkName: "stockallot" */ "@/views/boss/allot/stockallot/template/update"),
        meta: {
            bread: false,
        }
    },
    // {
    //     path: "stockallot/apply",
    //     name: "saApplylist",
    //     component: () => import(/* webpackChunkName: "stockallot" */ "@/views/boss/allot/stockallot/apply/index"),
    //     meta: {
    //         model: 'stockallot'
    //     }
    // },
    // 分配结果下的三个列表
    {
        path: "stockallot/account",
        name: "saAccountlist",
        component: () => import(/* webpackChunkName: "stockallot" */ "@/views/boss/allot/stockallot/account/separate"),
    },
    {
        path: "stockallot/amazon", 
        name: "amazonAccountlist",
        component: () => import(/* webpackChunkName: "stockallot" */ "@/views/boss/allot/stockallot/account/amazon"),
        
    },
    {
        path: "stockallot/summary",
        name: "summaryAccountlist",
        component: () => import(/* webpackChunkName: "stockallot" */ "@/views/boss/allot/stockallot/account/summary"),
    },
    {
        path: "stockallot/lock",
        name: "saLocklist",
        component: () => import(/* webpackChunkName: "stockallot" */ "@/views/boss/allot/stockallot/lock/index1"),
        // meta: {
        //     bread: false,
        // }
    },
    {
        path: "stockallot/notice",
        name: "saNoticelist",
        component: () => import(/* webpackChunkName: "stockallot" */ "@/views/boss/allot/stockallot/notice/index1"),
        // meta: {
        //     bread: false,
        // }
    },
    {
        path: "warehouse/account",
        name: "whAccountlist",
        component: () => import(/* webpackChunkName: "stockallot" */ "@/views/boss/allot/warehouse/account/index"),
        meta: {
            bread: false,
        }
    },
    {
        path: "warehouse/account/update/:type",
        name: "whUpdateAccount",
        component: () => import(/* webpackChunkName: "stockallot" */ "@/views/boss/allot/warehouse/account/update"),
        meta: {
            bread: false,
        }
    },
    {
        path: "account/serials",
        name: "acSerials",
        component: () => import(/* webpackChunkName: "stockallot" */ "@/views/boss/account/serials/index"),
    },
    {
        path: "task/center",
        name: "noCenter",
        component: () => import(/* webpackChunkName: "stockallot" */ "@/views/boss/task/center/index"),
    },

];
